import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { FC, useMemo } from 'react';
import { Tooltip } from '@idk-web/core-ui';
import { EidProvider } from '@idk-web/api';
import { translateProvider } from '@/utils/translation';
import Vipps from '@/assets/images/vipps-label.png';
import MobilePay from '@/assets/images/mobilepay-label.png';
import MitId from '@/assets/images/mitid-label.png';
import Freja from '@/assets/images/freja-label.png';
import BankIdNo from '@/assets/images/bankidno-label.png';
// import Ftn from '@/assets/images/ftn-label.png';
import BankId from '@/assets/images/bankid-label.png';

function getImage(provider: EidProvider): string {
  switch (provider) {
    case EidProvider.BANKID:
      return BankId;
    case EidProvider.FREJA:
      return Freja;
    case EidProvider.BANKID_NO:
      return BankIdNo;
    case EidProvider.MITID:
      return MitId;
    case EidProvider.FTN:
      return ''; // TODO
    case EidProvider.VIPPS:
      return Vipps;
    case EidProvider.MOBILE_PAY:
      return MobilePay;
  }
}

const EidProviderTooltip = styled(Tooltip)`
  padding: 6px 12px;
  background: ${({ theme }) => theme.palette.grayscale.white};
  color: black;
  border-radius: 4px;
`;

const EidProviderImage = styled.img`
  position: relative;
`;

export type EidProviderIconProps = {
  provider: EidProvider;
  withTooltip?: boolean;
};

const EidProviderIcon: FC<EidProviderIconProps> = ({
  provider,
  withTooltip = true,
}) => {
  const { t } = useTranslation();
  const image = useMemo(() => getImage(provider), [provider]);
  const label = useMemo(() => translateProvider(t, provider), [t, provider]);
  let height = 18;
  let marginTop = 0;

  switch (provider) {
    case EidProvider.BANKID:
      height = 32;
      break;
    case EidProvider.VIPPS:
      height = 24;
      marginTop = 8;
      break;
    case EidProvider.MOBILE_PAY:
      height = 28;
      break;
  }

  if (!image) {
    return null;
  }

  if (withTooltip) {
    return (
      <EidProviderTooltip content={label}>
        <EidProviderImage
          src={image}
          alt={label}
          style={{ height, marginTop }}
        />
      </EidProviderTooltip>
    );
  }

  return (
    <EidProviderImage src={image} alt={label} style={{ height, marginTop }} />
  );
};

export default EidProviderIcon;
